<app-modal-container
    #modalContainer
    (onClose)="close()"
    (onSave)="save()"
>
<!--  <div class="modal-header">-->
<!--    -->

<!--  </div>-->
  <div class="modal-body" *ngIf="isOpen">
    <div class="title-holder">
      <span class="icon">
        <svg width="27" height="27" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M25.5364 10.4154L14.8469 21.1049H5.76366V12.0216L16.4531 1.33211L25.5364 10.4154Z" fill="url(#paint0_linear_30844_46137)" stroke="url(#paint1_linear_30844_46137)"/>
            <path d="M5.264 11.8141L16.4531 0.625L18.869 3.04083L7.67983 14.23L5.264 21.6046L5.264 11.8141Z" fill="url(#paint2_linear_30844_46137)"/>
            <path d="M5.26562 21.605V18.4258L8.44484 21.605H5.26562Z" fill="#010101"/>
            <defs>
            <linearGradient id="paint0_linear_30844_46137" x1="21.3484" y1="5.52024" x2="4.912" y2="-4.61088" gradientUnits="userSpaceOnUse">
            <stop/>
            <stop offset="1" stop-color="white"/>
            </linearGradient>
            <linearGradient id="paint1_linear_30844_46137" x1="25.8251" y1="7.52248" x2="14.6879" y2="4.41288" gradientUnits="userSpaceOnUse">
            <stop stop-color="white" stop-opacity="0"/>
            <stop offset="0.428115" stop-color="white" stop-opacity="0.81428"/>
            <stop offset="1" stop-color="white" stop-opacity="0"/>
            </linearGradient>
            <linearGradient id="paint2_linear_30844_46137" x1="13.8111" y1="1.82522" x2="9.49029" y2="21.7488" gradientUnits="userSpaceOnUse">
            <stop stop-color="white"/>
            <stop offset="1" stop-color="white" stop-opacity="0"/>
            </linearGradient>
            </defs>
          </svg>
      </span>
      <h2>Висунути персональну пропозицію</h2>
    </div>
    <div class="request-data-holder">
      <div class="">

        <div class="flex justify-content-between">
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Статус</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  <app-redistribution-status  [status]="redistributionRequest.status"/>
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Медичний товар</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  {{ redistributionRequest.tradeName }}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Напрям</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  {{ redistributionRequest.direction }}
                </ng-container>
              </p>
            </div>
          </div>
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Кількість у запиті</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  {{ redistributionRequest.amount }}
                </ng-container>
              </p>
            </div>
          </div>
        </div>

        <div class="flex justify-content-between">
          <div class="col-3">
            <div class="form-group">
              <span class="subtitle">Дозування</span>
              <p class="content">
                <ng-container *ngIf="redistributionRequest; else emptyData">
                  {{ redistributionRequest.dosage === null ? '-' : redistributionRequest.dosage}}
                </ng-container>
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="request-data-form">
      <form [formGroup]="form">
        <div class="">

          <div class="flex justify-content-between">
            <div class="col-12">
              <div class="form-group">
                <span class="subtitle">Від імені закладу</span>
                <app-dropdown
                    [placeholder]="'Заклад для якого створюється запит'"
                    [multipleSelect]="false"
                    [items]="userOrganisationsForList"
                    (itemSelected)="onSelectOrganization($event)"
                    [fullWidth]="true"
                    [isError]="form.controls['organizationId'].invalid && form.controls['organizationId'].touched"

                />
                <span class="error" *ngIf="form.controls['organizationId'].invalid && form.controls['organizationId'].touched">Виберіть назву закладу</span>
              </div>
            </div>
          </div>

          <div class="flex justify-content-between">
            <div class="col-6">
              <div class="form-group">
                <span class="subtitle">Придатний до / Серія / Кат. номер</span>
                <app-dropdown
                    [placeholder]="'Придатний до / Серія / Кат. номер'"
                    [multipleSelect]="false"
                    [items]="medicatedMedicineMedicalDevicesForList"
                    (itemSelected)="onMedicalDevicesSelect($event)"
                    [isError]="form.controls['medicineMedicalDeviceId'].invalid && form.controls['medicineMedicalDeviceId'].touched"
                    [fullWidth]="true"

                />
                <span class="error" *ngIf="form.controls['medicineMedicalDeviceId'].invalid && form.controls['medicineMedicalDeviceId'].touched">Виберіть медичний засіб</span>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <span class="subtitle">Кількість</span>
                <input type="number" min="1" formControlName="offeredAmount">
                <span class="error" *ngIf="form.controls['offeredAmount'].invalid && form.controls['offeredAmount'].touched">Кількість повинна бути 1 або більше</span>
                <span class="error" *ngIf="maxAmountError && form.controls['offeredAmount'].value > maxAmount">Кількість перевищує доступний залишок {{ maxAmount }}. Зменшіть кількість аби продовжити</span>
                <span class="error" *ngIf="maxAmountError1 && form.controls['offeredAmount'].value > maxAmount1">Кількість у пропозиції перевищує кількість медичного товару у запиті. Пропозиція можлива на {{ maxAmount1 }} одиниць</span>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="flex justify-content-center">
      <button class="btn btn-grey" (click)="cancel()">Відмінити</button>
      <button class="btn btn-black" (click)="save()">Підтвердити</button>
    </div>

  </div>

  <ng-template #emptyData>-</ng-template>

  <app-loading-animation *ngIf="isLoading"></app-loading-animation>

</app-modal-container>